import { render, staticRenderFns } from "./menu-dialer.vue?vue&type=template&id=7683f020&"
import script from "./menu-dialer.vue?vue&type=script&lang=js&"
export * from "./menu-dialer.vue?vue&type=script&lang=js&"
import style0 from "./menu-dialer.vue?vue&type=style&index=0&id=7683f020&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports